import { render, staticRenderFns } from "./ValidationTaskModal.vue?vue&type=template&id=6ff10896&"
import script from "./ValidationTaskModal.vue?vue&type=script&lang=js&"
export * from "./ValidationTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports